// src/supabaseClient.js — Client Supabase LHM Madagascar
import { createClient } from '@supabase/supabase-js';

const supabaseUrl     = 'https://iwhoguejpikrfsriiuec.supabase.co';
const supabaseAnonKey = 'sb_publishable_izYVjN9CocE0nTbmwzePgQ_FkTOfE7p';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  global: {
    headers: {
      'x-app-name': 'lhm-madagascar',
    },
    // Pas de fetch personnalisé : un AbortController ici interrompt les
    // requêtes internes de Supabase (refresh token) → erreurs 403 + perte
    // de session après quelques minutes.
  },
  db: {
    schema: 'public',
  },
  realtime: {
    params: { eventsPerSecond: 2 },
  },
});

// ── Helpers pour les opérations courantes ──────────────────
export const supabaseHelpers = {
  async getPersonnel() {
    return supabase.from('personnel').select('*, services(name)');
  },
  async createPersonnel(data) {
    return supabase.from('personnel').insert([data]).select();
  },
  async updatePersonnel(id, updates) {
    return supabase.from('personnel').update(updates).eq('id', id).select();
  },
  async deletePersonnel(id) {
    return supabase.from('personnel').delete().eq('id', id);
  },
  async getServices() {
    return supabase.from('services').select('*');
  },
  async getAbsences() {
    return supabase.from('absences').select('*, personnel(first_name, last_name)');
  },
  async createAbsence(data) {
    return supabase.from('absences').insert([data]).select();
  },
  async getStockArticles() {
    return supabase.from('stock_articles').select('*');
  },
  async createStockArticle(data) {
    return supabase.from('stock_articles').insert([data]).select();
  },
  async updateStockArticle(id, updates) {
    return supabase.from('stock_articles').update(updates).eq('id', id).select();
  },
  async deleteStockArticle(id) {
    return supabase.from('stock_articles').delete().eq('id', id);
  },
  async getStockMouvements() {
    return supabase.from('stock_mouvements').select('*, stock_articles(name, reference)');
  },
  async createStockMouvement(data) {
    return supabase.from('stock_mouvements').insert([data]).select();
  },
  async getVolontaires() {
    return supabase.from('volontaires').select('*');
  },
  async createVolontaire(data) {
    return supabase.from('volontaires').insert([data]).select();
  },
  async updateVolontaire(id, updates) {
    return supabase.from('volontaires').update(updates).eq('id', id).select();
  },
  async getProjets() {
    return supabase.from('projets').select('*, services(name)');
  },
  async createProjet(data) {
    return supabase.from('projets').insert([data]).select();
  },
  async updateProjet(id, updates) {
    return supabase.from('projets').update(updates).eq('id', id).select();
  },
  async getBCCStudents() {
    return supabase.from('bcc_students').select('*');
  },
  async createBCCStudent(data) {
    return supabase.from('bcc_students').insert([data]).select();
  },
  async updateBCCStudent(id, updates) {
    return supabase.from('bcc_students').update(updates).eq('id', id).select();
  },
  async getBCCLessons(studentId) {
    return supabase.from('bcc_lessons').select('*').eq('student_id', studentId);
  },
  async createBCCLesson(data) {
    return supabase.from('bcc_lessons').insert([data]).select();
  },
  // Auth helpers
  async signIn(email, password) {
    return supabase.auth.signInWithPassword({ email, password });
  },
  async signOut() {
    return supabase.auth.signOut();
  },
  async getCurrentUser() {
    const { data: { user } } = await supabase.auth.getUser();
    return user;
  },
  onAuthStateChange(callback) {
    return supabase.auth.onAuthStateChange(callback);
  },
};

export default supabase;
